import { FormModel } from 'submodules/nerit-framework-ui/common/form-state-manager/types/FormModel'
import { IsOptional } from 'class-validator'
import { IsRequired } from 'submodules/nerit-framework-utils/validators'
import { IDateRangeFilter } from 'submodules/nerit-framework-ui/common/components/form-fields/date-range-picker/inner/IDateRangeFilter'

export class CollectionControlFiltersFormModel extends FormModel {

    @IsRequired()
    locationCodes?: number[]

    @IsOptional()
    matrixCode?: number

    /** Intervalo de datas; apenas mes e ano sao enviados ao backend. */
    @IsRequired()
    dateRange?: IDateRangeFilter

    constructor(initialData?: Partial<CollectionControlFiltersFormModel>) {
        super(initialData)
        Object.assign(this, initialData)
    }

}
